export default {
  "mainVegetable": "ovochi",
  "mainVegetable/01": "ovochi/baklazhany",
  "mainVegetable/02": "ovochi/sparzha",
  "mainVegetable/03": "ovochi/avokado",
  "mainVegetable/04": "ovochi/buriak",
  "mainVegetable/05": "ovochi/brokoli",
  "mainVegetable/06": "ovochi/morkva",
  "mainVegetable/07": "ovochi/selera",
  "mainVegetable/08": "ovochi/hryby",
  "mainVegetable/09": "ovochi/kapusta",
  "mainVegetable/10": "ovochi/briusselska-kapusta",
  "mainVegetable/11": "ovochi/pekinska-kapusta",
  "mainVegetable/12": "ovochi/tsvitna-kapusta",
  "mainVegetable/13": "ovochi/salat-koul-slou",
  "mainVegetable/14": "ovochi/ohirok",
  "mainVegetable/15": "ovochi/kabachky",
  "mainVegetable/16": "ovochi/tsykorii-salatnyi",
  "mainVegetable/17": "ovochi/shpynat",
  "mainVegetable/18": "ovochi/kvasolia-fava",
  "mainVegetable/19": "ovochi/kvasolia-flazhole",
  "mainVegetable/20": "ovochi/ploska-struchkova-kvasolia",
  "mainVegetable/21": "ovochi/sushena-kvasolia",
  "mainVegetable/22": "ovochi/zelena-kvasolia",
  "mainVegetable/23": "ovochi/sochevytsia",
  "mainVegetable/24": "ovochi/makedonska-ovocheva-sumish",
  "mainVegetable/25": "ovochi/kukurudza",
  "mainVegetable/26": "ovochi/sumish-molodykh-lystiv-salatu",
  "mainVegetable/27": "ovochi/ripa",
  "mainVegetable/28": "ovochi/tsybulia",
  "mainVegetable/29": "ovochi/soievi-boby",
  "mainVegetable/30": "ovochi/perets",
  "mainVegetable/31": "ovochi/kartoplia",
  "mainVegetable/32": "ovochi/parostky-soi",
  "mainVegetable/33": "ovochi/redyska",
  "mainVegetable/34": "ovochi/salat-dubolystyi",
  "mainVegetable/35": "ovochi/kucheriavyi-salat",
  "mainVegetable/36": "ovochi/salat-aisberh",
  "mainVegetable/37": "ovochi/piemontskyi-salat",
  "mainVegetable/38": "ovochi/salat-z-rysom",
  "mainVegetable/39": "ovochi/salat-romano",
  "mainVegetable/40": "ovochi/molode-lystia",
  "mainVegetable/41": "ovochi/latuk",
  "mainVegetable/42": "ovochi/mash-salat",
  "mainVegetable/43": "ovochi/rukola",
  "mainVegetable/44": "ovochi/kozloborodnyk",
  "mainVegetable/45": "ovochi/tabule",
  "mainVegetable/46": "ovochi/pomidory",
  "mainVegetable/47": "ovochi/zhovta-struchkova-kvasolia",
  "mainVegetable/48": "ovochi/nut",
  "mainVegetable/49": "ovochi/tsybulia-porei",
  "mainVegetable/50": "ovochi/harbuz",
  "mainVegetable/51": "ovochi/chervona-kvasolia",
  "mainVegetable/52": "ovochi/yabluka",
  "mainVegetable/53": "ovochi/yistivni-kashtany",
  "mainVegetable/54": "ovochi/chornoslyv",
  "mainVegetable/55": "ovochi/ovochi-miks",
  "mainVegetable/56": "ovochi/maslyny",
  "mainVegetable/57": "ovochi/artyshok",
  "mainVegetable/58": "ovochi/chervonyi-perets",
  "mainVegetable/59": "ovochi/zelena-struchkova-kvasolia",
  "mainVegetable/60": "ovochi/vesniana-ovocheva-sumish",
  "mainVegetable/61": "ovochi/ratatui",
  "mainVegetable/62": "ovochi/kus-kus",
  "mainVegetable/63": "ovochi/tazhyn",
  "mainVegetable/64": "ovochi/ovochi-v-kari",
  "mainVegetable/65": "ovochi/rozkolotyi-sushenyi-horokh",
  "mainVegetable/67": "ovochi/chervona-sochevytsia",
  "mainVegetable/68": "ovochi/kinoa",
  "mainVegetable/69": "ovochi/polba",
  "mainVegetable/70": "ovochi/bulhur",
  "mainVegetable/71": "ovochi/chervona-kapusta",
  "mainVegetable/72": "ovochi/keil",
  "mainVegetable/73": "ovochi/kervel",
  "mainVegetable/74": "ovochi/zerna-ta-nasinnia",
  "mainVegetable/75": "ovochi/bobovi",
  "mainVegetable/76": "ovochi/batat",
  "mainVegetable/77": "ovochi/harbuz",
  "mainVegetable/78": "ovochi/shchavel",
  "mainVegetable/79": "ovochi/kvasolia",
  "mainVegetable/80": "ovochi/zelenyi-horoshok-z-morkvoiu",
  "mainVegetable/81": "ovochi/horoshok",
  "mainVegetable/82": "ovochi/edamame",
  "mainVegetable/83": "ovochi/yachmin",
  "mainVegetable/84": "ovochi/salatna-sumish",
  "mainVegetable/85": "ovochi/salatnyi-tsykorii",
  "mainVegetable/86": "ovochi/salat-romano",
  "mainVegetable/87": "ovochi/molodyi-shpynat",
  "mainVegetable/88": "ovochi/salat-lollo-verde",
  "mainVegetable/89": "ovochi/manhold",
  "mainVegetable/90": "ovochi/pasternak",
  "mainVegetable/91": "ovochi/chornyi-rys",
  "mainVegetable/92": "ovochi/sumish-kvasolei",
  "mainVegetable/93": "ovochi/chorna-kvasolia",
  "mainVegetable/94": "ovochi/konichna-kapusta",
  "mainVegetable/95": "ovochi/bila-kvasolia",
  "mainVegetable/96": "ovochi/susheni-pomidory",
  "mainVegetable/97": "ovochi/ovocheva-sumish",
  "mainVegetable/98": "ovochi/muskatnyi-harbuz",
  "productRange": "asortyment",
  "productRange/4G_BIO": "asortyment/4g-bio",
  "productRange/4G_SRP": "asortyment/4g-srp",
  "productRange/BEAN_SAUCE": "asortyment/kvasolia-v-sousi",
  "productRange/BEANS": "asortyment",
  "productRange/BIO": "asortyment/bio",
  "productRange/BON_SENGAG": "asortyment/bonduelle-bere-zoboviazannia",
  "productRange/BOND_KIDS": "asortyment",
  "productRange/CAN_A_POEL": "asortyment/ovochi-dlia-smazhennia",
  "productRange/CAN_BIO": "asortyment",
  "productRange/CAN_BOCAL": "asortyment",
  "productRange/CAN_PETITS": "asortyment",
  "productRange/CAN_SEC_BI": "asortyment/vareni-susheni-ovochi-v-duzhe-malii-kilkosti-ridyny-bio",
  "productRange/CAN_SEC_CO": "asortyment/pryhotovani-susheni-ovochi",
  "productRange/CAN_SEC_CU": "asortyment/vareni-susheni-ovochi-v-duzhe-malii-kilkosti",
  "productRange/CAN_SEC_NA": "asortyment/naturalni-susheni-ovochi",
  "productRange/CAN_SEC_PR": "asortyment",
  "productRange/CAN_VAPEUR": "asortyment/ovochi-na-pari",
  "productRange/CAN_VEG_SA": "asortyment/naturalni-ovochi",
  "productRange/CAN_VEG_SR": "asortyment/naturalni-ovochi",
  "productRange/CARTA_DELL": "asortyment",
  "productRange/CEREAL_CAN": "asortyment",
  "productRange/CEREAL_FRZ": "asortyment",
  "productRange/CEREALI": "asortyment",
  "productRange/CEREALLEGR": "asortyment",
  "productRange/CLASSICVEG": "asortyment/klasychni-ovochi",
  "productRange/COCCOLE": "asortyment",
  "productRange/COLDVEGE": "asortyment/kholodni-ovochi",
  "productRange/COO_VEG": "asortyment",
  "productRange/COOKMUSH": "asortyment/pryhotovani-pecherytsi",
  "productRange/CORN": "asortyment",
  "productRange/CREATIF": "asortyment/kreatyvnyi",
  "productRange/CROUSTIS": "asortyment/khrumke",
  "productRange/CRUDITES": "asortyment/svizhi-ovochi",
  "productRange/DE_NOS_PRO": "asortyment/vid-nashykh-vyrobnykiv",
  "productRange/DOYMUSHACC": "asortyment/hryby-yak-harnir",
  "productRange/DOYMUSHAPE": "asortyment/hryby-dlia-aperytyvu",
  "productRange/DRYVEGE": "asortyment/susheni-ovochi",
  "productRange/FRANCAIS": "asortyment/100-frantsuzkyi",
  "productRange/FROZENVEGE": "asortyment/zamorozheni-ovochi-dlia-podilu",
  "productRange/FRZ_ASTUCE": "asortyment/moi-porady-shchodo-ovochiv",
  "productRange/FRZ_FRY_MI": "asortyment",
  "productRange/FRZ_GRATIN": "asortyment/zapikanky",
  "productRange/FRZ_JUSTEA": "asortyment/zamorozheni-monoovochi",
  "productRange/FRZ_KELLO": "asortyment/zamorozheni-susheni-ovochi-ta-zlaky",
  "productRange/FRZ_LEG_CO": "asortyment/tradytsiini-zamorozheni-ovochi",
  "productRange/FRZ_MELANG": "asortyment/ovochevi-sumishi",
  "productRange/FRZ_POELEE": "asortyment/poperedno-prigotovani-ovochi",
  "productRange/FRZ_PUREES": "asortyment/zamorozhene-piure",
  "productRange/FRZ_VEG_BI": "asortyment/bio-zamorozheni-produkty",
  "productRange/FRZ_VEG_SR": "asortyment/srp-zamorozheni-produkty",
  "productRange/INDFROZVEG": "asortyment/indyvidualno-zamorozheni-ovochi",
  "productRange/INSALATE_D": "asortyment",
  "productRange/INSALATONA": "asortyment/velyka-salatna-portsiia",
  "productRange/JEUNES_POU": "asortyment/molode-lystia",
  "productRange/LAITUES": "asortyment/latuk",
  "productRange/LE_REGIONA": "asortyment",
  "productRange/LEGUMIO": "asortyment/lehumio",
  "productRange/LOOP": "asortyment/lup",
  "productRange/LUNCH_BOWL": "asortyment/obidnii-boul",
  "productRange/MACHE_BASE": "asortyment/mash-salat-ta-osnova-z-mashu",
  "productRange/MEL_LAITUE": "asortyment/sumish-latukiv",
  "productRange/MIXES_CORN": "asortyment",
  "productRange/MONO_VEGE": "asortyment/monoovochi",
  "productRange/MUSHNATEMI": "asortyment/narizani-naturalni-hryby",
  "productRange/MUSHNATENT": "asortyment/tsili-naturalni-hryby",
  "productRange/MUSHNATEPA": "asortyment/tovsto-narizani-naturalni-hryby",
  "productRange/MUSHNATMIN": "asortyment/mini-hryby-naturalni",
  "productRange/MUSHROOMS": "asortyment/hryby",
  "productRange/NAT_MIX": "asortyment",
  "productRange/NATURA_IN": "asortyment",
  "productRange/OTHER_VEG": "asortyment/gotovi-ovochi",
  "productRange/PEAS": "asortyment",
  "productRange/PREPARED_VEG": "asortyment/hotovi-ovochi",
  "productRange/RAWOCOOK": "asortyment",
  "productRange/READY_FROZ": "asortyment/hotovi-zamorozheni-stravy",
  "productRange/SALABIS": "asortyment/salat",
  "productRange/SOUPS": "asortyment/ovochi-dlya-krem-supiv",
  "productRange/SPINACH": "asortyment",
  "productRange/STEAM_CAN": "asortyment/na-paru",
  "productRange/STEAM_FRZ": "asortyment/vapeur-ovochi-poperedno-prigotovani-na-pari",
  "productRange/STEAM_MIX": "asortyment/zamorozheni-ovochevi-sumishi-dlia-pryhotuvannia-na-paru",
  "productRange/STUZZICHIA": "asortyment",
  "productRange/SUNVEGE": "asortyment/seredzemnomorski-ovochi",
  "productRange/TOUCHE": "asortyment/minikonservi",
  "productRange/TRAIT_CRUD": "asortyment/ovochevi-zakusky",
  "productRange/TRAIT_SAL": "asortyment/ovochi-dlya-salativ",
  "productRange/TRAIT_TABO": "asortyment/tabule",
  "productRange/TUS_RECETA": "asortyment/tvoi-retsepty",
  "productRange/VEG_TO_FRY": "asortyment",
  "productRange/VEGGIE": "asortyment/ovochevyi-rys",
  "productRange/WORLDVEGE": "asortyment/ovochi-svitu",
  "season": "sezony",
  "season/1": "sezony/lito",
  "season/2": "sezony/osin",
  "season/3": "sezony/zyma",
  "season/4": "sezony/vesna",
  "season/5": "sezony/rizdvo",
  "technologie": "tekhnolohiia",
  "technologie/AC01": "tekhnolohiia/konservy",
  "technologie/AD01": "tekhnolohiia/zamorozhenyi",
  "technologie/AG01": "tekhnolohiia/svizhyi",
  "technologie/AT01": "tekhnolohiia/kulinariia",
  "recipeDish": "typ",
  "recipeDish/ACC": "typ/harnir",
  "recipeDish/APE": "typ/aperytyv",
  "recipeDish/DES": "typ/desert",
  "recipeDish/ENT": "typ/persha-strava",
  "recipeDish/PLAT": "typ/osnovna-strava",
  "recipeDish/SAL": "typ/salat",
  "recipeDish/SNA": "typ/perekus",
  "recipeDish/PDE": "typ/snidanok",
  "recipeDish/DEJ": "typ/obid",
  "recipeDish/TRA": "typ/tradytsiinyi",
  "recipeDish/GOU": "typ/hurmanskyi",
  "recipeDish/ETH": "typ/etnichnyi",
  "recipeDish/FCH": "typ/dlia-ditei",
  "recipeDish/SOU": "typ/sup",
  "pred-recipeTimingCook-facet": "vypikannia",
  "pred-recipeTimingCook-facet/0%20-%2015%20min": "vypikannia/0-15-khvylyn",
  "pred-recipeTimingCook-facet/15%20-%2030%20min": "vypikannia/15-30-khvylyn",
  "pred-recipeTimingCook-facet/30%20-%2045%20min": "vypikannia/30-45-khvylyn",
  "pred-recipeTimingCook-facet/45%20min%20and%20more": "vypikannia/45-khvylyn",
  "pred-recipeTimingPreparation-facet": "pidhotovka",
  "pred-recipeTimingPreparation-facet/0%20-%2015%20min": "pidhotovka/0-15-khvylyn",
  "pred-recipeTimingPreparation-facet/15%20-%2030%20min": "pidhotovka/15-30-khvylyn",
  "pred-recipeTimingPreparation-facet/30%20-%2045%20min": "pidhotovka/30-45-khvylyn",
  "pred-recipeTimingPreparation-facet/45%20min%20and%20more": "pidhotovka/45-khvylyn",
  "pred-recipeCost-Facet": "biudzhet",
  "pred-recipeCost-Facet/petit": "biudzhet/malyi",
  "pred-recipeCost-Facet/moyen": "biudzhet/serednii",
  "pred-recipeCost-Facet/grand": "biudzhet/velykyi",
  "recipeDifficulty": "pryhotuvannia",
  "recipeDifficulty/1": "pryhotuvannia/lehkyi",
  "recipeDifficulty/2": "pryhotuvannia/serednii",
  "recipeDifficulty/3": "pryhotuvannia/skladnyi",
  "recipeDishNumber": "portsii",
  "recipeDishNumber/1": "portsii/1",
  "recipeDishNumber/2": "portsii/2",
  "recipeDishNumber/3": "portsii/3",
  "recipeDishNumber/4": "portsii/4",
  "recipeDishNumber/5": "portsii/5",
  "recipeDishNumber/6": "portsii/6",
  "recipeDishNumber/7": "portsii/7",
  "recipeDishNumber/8": "portsii/8",
  "productTheme": "produkty-za-temoiu",
  "productTheme/ACC": "produkty-za-temoiu/harnir",
  "productTheme/BEA": "produkty-za-temoiu/kvasolia",
  "productTheme/BIS": "produkty-za-temoiu/kvasolia-u-sousi",
  "productTheme/BIO": "produkty-za-temoiu/bio",
  "productTheme/CAN": "produkty-za-temoiu/konservy",
  "productTheme/CER": "produkty-za-temoiu/zlaky",
  "productTheme/CLS": "produkty-za-temoiu/klasychni",
  "productTheme/DLE": "produkty-za-temoiu/ovochi",
  "productTheme/EDR": "produkty-za-temoiu/dopovnennia-do-strav",
  "productTheme/ENT": "produkty-za-temoiu/pershi-stravy",
  "productTheme/FRZ": "produkty-za-temoiu/zamorozhenyi",
  "productTheme/FSD": "produkty-za-temoiu/dlia-salativ",
  "productTheme/FSH": "produkty-za-temoiu/svizhyi",
  "productTheme/ING": "produkty-za-temoiu/inhrediienty-dlia-moikh-retseptiv",
  "productTheme/JAR": "produkty-za-temoiu/ovochi-v-bankakh",
  "productTheme/LBW": "produkty-za-temoiu/lanch-boul",
  "productTheme/LDF": "produkty-za-temoiu/zapecheni-v-dukhovtsi",
  "productTheme/LEG": "produkty-za-temoiu/bobovi",
  "productTheme/LGO": "produkty-za-temoiu/lehumio",
  "productTheme/LGR": "produkty-za-temoiu/ovochi-na-hryli",
  "productTheme/LGS": "produkty-za-temoiu/ovochi-dlia-supiv",
  "productTheme/MAI": "produkty-za-temoiu/kukurudza",
  "productTheme/MUS": "produkty-za-temoiu/hryby",
  "productTheme/NEW": "produkty-za-temoiu/novi-produkty",
  "productTheme/PDH": "produkty-za-temoiu/hotovi-stravy-z-bobovykh",
  "productTheme/PDL": "produkty-za-temoiu/koshyk-ovochiv",
  "productTheme/PHR": "produkty-za-temoiu/makarony-ta-rys-iz-bobovykh",
  "productTheme/PLP": "produkty-za-temoiu/osnovna-strava",
  "productTheme/RAL": "produkty-za-temoiu/rys-z-ovochamy",
  "productTheme/RDM": "produkty-za-temoiu/hotovi-stravy",
  "productTheme/SAL": "produkty-za-temoiu/use-dlia-moikh-salativ",
  "productTheme/SDB": "produkty-za-temoiu/salatni-bouly",
  "productTheme/SNK": "produkty-za-temoiu/sneky",
  "productTheme/SUP": "produkty-za-temoiu/sup",
  "productTheme/TEX": "produkty-za-temoiu/tekhasko-meksykanska-kukhnia",
  "productTheme/VGP": "produkty-za-temoiu/roslynni-bilky",
  "recipeTheme": "retsepty-za-temoiu",
  "recipeTheme/01": "retsepty-za-temoiu/sviatkovi-retsepty",
  "recipeTheme/02": "retsepty-za-temoiu/aperytyv",
  "recipeTheme/03": "retsepty-za-temoiu/salaty-ta-sneky",
  "recipeTheme/04": "retsepty-za-temoiu/supy-ta-haspacho",
  "recipeTheme/05": "retsepty-za-temoiu/kyshi-tartaletky-ta-zapikanky",
  "recipeTheme/06": "retsepty-za-temoiu/spetsialno-dlia-ditei",
  "recipeTheme/07": "retsepty-za-temoiu/deserty",
  "recipeTheme/08": "retsepty-za-temoiu/vehetarianski",
  "recipeTheme/09": "retsepty-za-temoiu/harniry",
  "recipeTheme/10": "retsepty-za-temoiu/z-inshykh-krain",
  "recipeTheme/11": "retsepty-za-temoiu/tushkovani-stravy",
  "recipeTheme/12": "retsepty-za-temoiu/salaty-ta-barbekiu",
  "recipeTheme/13": "retsepty-za-temoiu/sneky-ta-zakusky",
  "recipeTheme/14": "retsepty-za-temoiu/osnovna-strava",
  "recipeTheme/15": "retsepty-za-temoiu/deserty-ta-vypichka",
  "recipeTheme/16": "retsepty-za-temoiu/zakusky-ta-supy",
  "recipeTheme/17": "retsepty-za-temoiu/salaty",
  "recipeTheme/18": "retsepty-za-temoiu/bouly",
  "recipeTheme/19": "retsepty-za-temoiu/supy",
  "recipeTheme/20": "retsepty-za-temoiu/perekusy",
  "recipeTheme/21": "retsepty-za-temoiu/sous",
  "recipeTheme/22": "retsepty-za-temoiu/povnotsinni-stravy",
  "recipeTheme/23": "retsepty-za-temoiu/inshi-stravy",
  "recipeTheme/24": "retsepty-za-temoiu/zapecheni-stravy",
  "recipeTheme/25": "retsepty-za-temoiu/meksykanskyi",
  "recipeTheme/26": "retsepty-za-temoiu/navkolo-svitu",
  "recipeTheme/27": "retsepty-za-temoiu/den-bez-miasa",
  "recipeTheme/28": "retsepty-za-temoiu/nyzkyi-vmist-vuhlevodiv",
  "recipeTheme/33": "retsepty-za-temoiu/na-osnovi-sochevytsi",
  "recipeTheme/34": "retsepty-za-temoiu/na-osnovi-tsvitnoi-kapusty",
  "recipeTheme/35": "retsepty-za-temoiu/na-osnovi-kartopli",
  "recipeTheme/36": "retsepty-za-temoiu/na-osnovi-morkvy",
  "recipeTheme/37": "retsepty-za-temoiu/na-osnovi-shpynatu",
  "recipeTheme/38": "retsepty-za-temoiu/na-osnovi-pertsiu",
  "recipeTheme/39": "retsepty-za-temoiu/na-osnovi-hrybiv",
  "recipeTheme/40": "retsepty-za-temoiu/na-osnovi-struchkovoi-kvasoli",
  "recipeTheme/41": "retsepty-za-temoiu/na-osnovi-kukurudzy",
  "recipeTheme/42": "retsepty-za-temoiu/na-osnovi-zelenoho-horoshku",
  "recipeTheme/43": "retsepty-za-temoiu/na-osnovi-chervonoi-kvasoli",
  "recipeTheme/44": "retsepty-za-temoiu/na-osnovi-flazhole",
  "recipeTheme/45": "retsepty-za-temoiu/na-osnovi-nutu",
  "recipeTheme/46": "retsepty-za-temoiu/na-osnovi-brokoli",
  "pred-particularite": "kharchovi-zvychky",
  "pred-particularite/Sans%20conservateur": "kharchovi-zvychky/bez-konservantiv",
  "pred-particularite/Sel%20naturellement%20pr%E9sent": "kharchovi-zvychky/pryrodno-prysutnia-sil",
  "pred-particularite/Sans%20colorant": "kharchovi-zvychky/bez-barvnykiv",
  "pred-particularite/Sans%20sucre%20ajout%E9": "kharchovi-zvychky/bez-dodanoho-tsukru",
  "pred-particularite/Sans%20sel%20ajout%E9": "kharchovi-zvychky/bez-dodanoi-soli",
  "pred-particularite/Sans%20additif": "kharchovi-zvychky/bez-dobavok",
  "pred-particularite/": "kharchovi-zvychky/pryrodno-prysutnia-sil",
  "pred-particularite/Sans%20lactose": "kharchovi-zvychky/bez-laktozy",
  "pred-particularite/Sans%20gluten": "kharchovi-zvychky/bez-hliutenu",
  "pred-particularite/V%E9g%E9tarien": "kharchovi-zvychky/vehetarianske",
  "pred-particularite/V%E9g%E9talien": "kharchovi-zvychky/vehanske",
  "pred-particularite/Sans%20sulfite": "kharchovi-zvychky/bez-sulfitiv",
  "pred-particularite/A%20la%20vapeur": "kharchovi-zvychky/na-paru",
  "pred-particularite/Sans%20condiment": "kharchovi-zvychky/bez-pryprav",
  "cultureType": "typ-vyroshchuvannia",
  "cultureType/Bio": "typ-vyroshchuvannia/orhanichne",
  "cultureType/Sans%20r%E9sidu%20de%20pesticide": "typ-vyroshchuvannia/bez-zalyshkiv-pestytsydiv",
  "cultureType/Sans%20OGM": "typ-vyroshchuvannia/bez-hmo",
  "nutriscore": "nutriscore",
  "pred-particularite/recipeVegan": "kharchovi-zvychky/vehanskyi",
  "pred-particularite/recipeVeggie": "kharchovi-zvychky/vehetarianskyi",
  "pred-particularite/recipeGlutenfree": "kharchovi-zvychky/bezghliutenovyi",
  "pred-particularite/recipeLactosefree": "kharchovi-zvychky/bezlaktoznyi",
  "cultureOrigin": "kraina-vyroshchuvannia",
  "cultureOrigin/31": "kraina-vyroshchuvannia/azerbaidzhan",
  "cultureOrigin/32": "kraina-vyroshchuvannia/arhentyna",
  "cultureOrigin/36": "kraina-vyroshchuvannia/avstraliia",
  "cultureOrigin/40": "kraina-vyroshchuvannia/avstriia",
  "cultureOrigin/51": "kraina-vyroshchuvannia/virmeniia",
  "cultureOrigin/56": "kraina-vyroshchuvannia/belhiia",
  "cultureOrigin/68": "kraina-vyroshchuvannia/boliviia",
  "cultureOrigin/70": "kraina-vyroshchuvannia/bosniia-i-hertsehovyna",
  "cultureOrigin/76": "kraina-vyroshchuvannia/brazyliia",
  "cultureOrigin/97": "kraina-vyroshchuvannia/yevropeiskyi-soiuz",
  "cultureOrigin/100": "kraina-vyroshchuvannia/bolhariia",
  "cultureOrigin/104": "kraina-vyroshchuvannia/mianma",
  "cultureOrigin/120": "kraina-vyroshchuvannia/kamerun",
  "cultureOrigin/124": "kraina-vyroshchuvannia/kanada",
  "cultureOrigin/152": "kraina-vyroshchuvannia/chyli",
  "cultureOrigin/156": "kraina-vyroshchuvannia/kytai",
  "cultureOrigin/188": "kraina-vyroshchuvannia/kosta-ryka",
  "cultureOrigin/191": "kraina-vyroshchuvannia/khorvatiia",
  "cultureOrigin/196": "kraina-vyroshchuvannia/kipr",
  "cultureOrigin/203": "kraina-vyroshchuvannia/chekhiia",
  "cultureOrigin/208": "kraina-vyroshchuvannia/daniia",
  "cultureOrigin/231": "kraina-vyroshchuvannia/efiopiia",
  "cultureOrigin/233": "kraina-vyroshchuvannia/estoniia",
  "cultureOrigin/246": "kraina-vyroshchuvannia/finliandiia",
  "cultureOrigin/250": "kraina-vyroshchuvannia/frantsiia",
  "cultureOrigin/258": "kraina-vyroshchuvannia/frantsuzka-polineziia",
  "cultureOrigin/276": "kraina-vyroshchuvannia/nimechchyna",
  "cultureOrigin/300": "kraina-vyroshchuvannia/hretsiia",
  "cultureOrigin/320": "kraina-vyroshchuvannia/hvatemala",
  "cultureOrigin/344": "kraina-vyroshchuvannia/honkonh",
  "cultureOrigin/348": "kraina-vyroshchuvannia/uhorshchyna",
  "cultureOrigin/352": "kraina-vyroshchuvannia/islandiia",
  "cultureOrigin/356": "kraina-vyroshchuvannia/indiia",
  "cultureOrigin/360": "kraina-vyroshchuvannia/indoneziia",
  "cultureOrigin/372": "kraina-vyroshchuvannia/irlandiia",
  "cultureOrigin/376": "kraina-vyroshchuvannia/izrail",
  "cultureOrigin/380": "kraina-vyroshchuvannia/italiia",
  "cultureOrigin/398": "kraina-vyroshchuvannia/kazakhstan",
  "cultureOrigin/404": "kraina-vyroshchuvannia/keniia",
  "cultureOrigin/414": "kraina-vyroshchuvannia/kuveit",
  "cultureOrigin/417": "kraina-vyroshchuvannia/kyrhyzstan",
  "cultureOrigin/422": "kraina-vyroshchuvannia/livan",
  "cultureOrigin/428": "kraina-vyroshchuvannia/latviia",
  "cultureOrigin/440": "kraina-vyroshchuvannia/lytva",
  "cultureOrigin/442": "kraina-vyroshchuvannia/liuksemburh",
  "cultureOrigin/450": "kraina-vyroshchuvannia/madahaskar",
  "cultureOrigin/470": "kraina-vyroshchuvannia/malta",
  "cultureOrigin/480": "kraina-vyroshchuvannia/mavrykii",
  "cultureOrigin/484": "kraina-vyroshchuvannia/meksyka",
  "cultureOrigin/498": "kraina-vyroshchuvannia/moldova",
  "cultureOrigin/499": "kraina-vyroshchuvannia/chornohoriia",
  "cultureOrigin/504": "kraina-vyroshchuvannia/marokko",
  "cultureOrigin/528": "kraina-vyroshchuvannia/niderlandy",
  "cultureOrigin/548": "kraina-vyroshchuvannia/vanuatu",
  "cultureOrigin/578": "kraina-vyroshchuvannia/norvehiia",
  "cultureOrigin/586": "kraina-vyroshchuvannia/pakystan",
  "cultureOrigin/604": "kraina-vyroshchuvannia/peru",
  "cultureOrigin/616": "kraina-vyroshchuvannia/polshcha",
  "cultureOrigin/620": "kraina-vyroshchuvannia/portuhaliia",
  "cultureOrigin/634": "kraina-vyroshchuvannia/katar",
  "cultureOrigin/642": "kraina-vyroshchuvannia/rumuniia",
  "cultureOrigin/643": "kraina-vyroshchuvannia/rosiia",
  "cultureOrigin/703": "kraina-vyroshchuvannia/slovachchyna",
  "cultureOrigin/704": "kraina-vyroshchuvannia/vʼietnam",
  "cultureOrigin/705": "kraina-vyroshchuvannia/sloveniia",
  "cultureOrigin/724": "kraina-vyroshchuvannia/ispaniia",
  "cultureOrigin/752": "kraina-vyroshchuvannia/shvetsiia",
  "cultureOrigin/756": "kraina-vyroshchuvannia/shveitsariia",
  "cultureOrigin/764": "kraina-vyroshchuvannia/tailand",
  "cultureOrigin/784": "kraina-vyroshchuvannia/obʼiednani-arabski-emiraty",
  "cultureOrigin/792": "kraina-vyroshchuvannia/turechchyna",
  "cultureOrigin/795": "kraina-vyroshchuvannia/turkmenistan",
  "cultureOrigin/804": "kraina-vyroshchuvannia/ukraina",
  "cultureOrigin/818": "kraina-vyroshchuvannia/yehypet",
  "cultureOrigin/826": "kraina-vyroshchuvannia/velyka-brytaniia",
  "cultureOrigin/834": "kraina-vyroshchuvannia/tanzaniia",
  "cultureOrigin/840": "kraina-vyroshchuvannia/ssha",
  "cultureOrigin/999": "kraina-vyroshchuvannia/eksport",
  "cultureOrigin/NON_EU": "kraina-vyroshchuvannia/za-mezhamy-yes",
  "cultureOrigin/UE": "kraina-vyroshchuvannia/yes",
  "cultureOrigin/XXX": "kraina-vyroshchuvannia/porozhno"
};
